<div class="row" *ngIf="isUploading" >
  <div class="col-12 text-center">
    <i class="pi pi-spin pi-spinner upload-spinner"></i>
  </div>
  <div class="col-12 text-center">File is being uploaded.</div>
</div>
<div class="row"  role="button" *ngIf="!isUploading" >
  <div class="col-12 text-center mt-2" *ngIf="!isNotesUpdated">
    <div class="input-group mb-3">
      <select [(ngModel)]="folders" #folder name="folder" class="form-control">
        <option [ngValue]="null" [disabled]="true">Select Folder</option>
        <option value="HR">HR</option>
        <option value="Supervisory">Supervisory</option>
        <option value="Compliance">Compliance</option>
        <option value="DD Team">DD Team</option>
        <option value="Misc">Misc</option>
      </select>
      <input type="text" class="form-control" [(ngModel)]="notes" placeholder="Add Description">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" type="button" (click)="updateNotes()" >Add</button>
      </div>
    </div>
    <small>Add the notes for the document being uploaded.</small>
  </div>
  <div tabindex="0" class="col-12 text-center upload-drop-zone" *ngIf="isNotesUpdated" (click)="fileInput.click()" (keydown.enter)="fileInput.click()">
    <p>{{notes}}</p>
    <i class="pi pi-cloud-upload upload-icon"></i>
    <p>click here to upload a file, max file size is 3mb.</p>
  </div>
</div>
<input
  id="fileUpload"
  #fileInput
  type="file"
  (change)="onFileChanged($event)"
  class="file-upload-input"
/>
